// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__1H1LD","empty":"ModalGraph_empty__1GRLP"};